var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRegUsername(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0007 0.833008C12.2844 0.833008 14.1359 2.77691 14.1359 5.17511C14.1359 7.57355 12.2844 9.51722 10.0007 9.51722C7.71697 9.51722 5.86523 7.57355 5.86523 5.17511C5.86523 2.77691 7.71697 0.833008 10.0007 0.833008Z",
    fill: "#7BCB45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7953 16.477C17.3481 13.2745 15.4093 10.6701 12.837 9.51758C12.092 10.3711 10.8988 10.6701 10.0043 10.6701C9.07229 10.6701 7.8793 10.3711 7.13346 9.51758C4.59878 10.6272 2.69739 13.1895 2.213 16.2638C2.06409 17.2031 2.62315 17.9718 3.44322 18.2705C5.04594 18.8256 7.58083 19.1667 10.0043 19.1667C13.2471 19.1667 15.2976 18.8256 16.7512 18.2279C17.4226 17.9284 17.907 17.2883 17.7953 16.477Z",
    fill: "#7BCB45",
    stroke: "#7BCB45",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRegUsername);
export default __webpack_public_path__ + "static/media/icRegUsername.47e1717cf14431532e1e7e015d6dbf2c.svg";
export { ForwardRef as ReactComponent };